export default "__VITE_PUBLIC_ASSET__c54ccb26__"